import { defaultConfig, defineSemanticTokens } from '@chakra-ui/react';

const semanticColors = defineSemanticTokens.colors({
    ...defaultConfig.theme?.semanticTokens?.colors,
    bg: {
        DEFAULT: { value: { base: '{colors.light}', _dark: '{colors.dark}' } },

        subtle: { value: { base: '{colors.gray.50}', _dark: '{colors.gray.900}' } },
        muted: { value: { base: '{colors.gray.200}', _dark: '{colors.gray.800}' } },
        emphasized: { value: { base: '{colors.gray.300}', _dark: '{colors.gray.700}' } },
        inverted: { value: { base: '{colors.dark}', _dark: '{colors.light}' } },

        panel: { value: { base: '{colors.gray.white}', _dark: '{colors.gray.900}' } },

        brand: { value: { base: '{colors.indigo.200}', _dark: '{colors.indigo.900}' } },
        danger: { value: { base: '{colors.red.100}', _dark: '{colors.red.900}' } },
        success: { value: { base: '{colors.green.100}', _dark: '{colors.green.900}' } },
        warning: { value: { base: '{colors.yellow.100}', _dark: '{colors.yellow.900}' } },
        info: { value: { base: '{colors.aqua.100}', _dark: '{colors.aqua.900}' } },
    },
    border: {
        DEFAULT: { value: { base: '{colors.gray.200}', _dark: '{colors.gray.800}' } },
        subtle: { value: { base: '{colors.gray.100}', _dark: '{colors.gray.800}' } },
        muted: { value: { base: '{colors.gray.300}', _dark: '{colors.gray.700}' } },
        emphasized: { value: { base: '{colors.gray.300}', _dark: '{colors.gray.500}' } },
        inverted: { value: { base: '{colors.gray.700}', _dark: '{colors.gray.200}' } },

        panel: { value: { base: '{colors.gray.200}', _dark: '{colors.gray.800}' } },

        danger: { value: { base: '{colors.red.500}', _dark: '{colors.red.400}' } },
        success: { value: { base: '{colors.green.600}', _dark: '{colors.aqua.500}' } },
        warning: { value: { base: '{colors.yellow.600}', _dark: '{colors.yellow.200}' } },
        info: { value: { base: '{colors.aqua.600}', _dark: '{colors.aqua.500}' } },
    },
    fg: {
        DEFAULT: { value: { base: '{colors.dark}', _dark: '{colors.light}' } },
        muted: { value: { base: '{colors.gray.700}', _dark: '{colors.gray.300}' } },
        subtle: { value: { base: '{colors.gray.500}', _dark: '{colors.gray.400}' } },
        inverted: { value: { base: '{colors.dark}', _dark: '{colors.light}' } },
        danger: { value: { base: '{colors.red.500}', _dark: '{colors.red.400}' } },
        success: { value: { base: '{colors.green.600}', _dark: '{colors.green.300}' } },
        warning: { value: { base: '{colors.yellow.600}', _dark: '{colors.yellow.300}' } },
        info: { value: { base: '{colors.aqua.600}', _dark: '{colors.aqua.300}' } },
    },
    brand: {
        contrast: {
            value: { base: 'white', _dark: 'white' },
        },
        fg: {
            value: { base: '{colors.indigo.700}', _dark: '{colors.indigo.300}' },
        },
        subtle: {
            value: { base: '{colors.indigo.100}', _dark: '{colors.indigo.900}' },
        },
        muted: {
            value: { base: '{colors.indigo.200}', _dark: '{colors.indigo.800}' },
        },
        emphasized: {
            value: { base: '{colors.indigo.300}', _dark: '{colors.indigo.700}' },
        },
        solid: {
            value: { base: '{colors.indigo.600}', _dark: '{colors.indigo.600}' },
        },
        focusRing: {
            value: { base: '{colors.indigo.500}', _dark: '{colors.indigo.500}' },
        },
    },
});

const semanticTokens = {
    ...defaultConfig.theme?.semanticTokens,
    colors: semanticColors,
};

export { semanticTokens };
